let _timestampInit = (new Date).getTime();

import Vue from 'vue';
import App from '@/App.vue';
import VueRouter from 'vue-router';

import i18n from '@/i18n';
import vco from "v-click-outside";
import Vuelidate from 'vuelidate';
import BootstrapVue from 'bootstrap-vue';
import VueToast from 'vue-toast-notification';
import VueSweetalert2 from 'vue-sweetalert2';
import VueApexCharts from 'vue-apexcharts';
import VueMask from 'v-mask';

import FlagIcon from 'vue-flag-icon'
import vueCountryRegionSelect from 'vue-country-region-select';
import RegionSelect from '@/components/RegionSelect.vue';
import io from 'socket.io-client';
import VueSocketIOExt from 'vue-socket.io-extended';
import VueSanitize from "vue-sanitize";
import store from '@/state/store';
import router from '@/router/index';
import { gameToGameIcon, gameToGameIconLarge, gameToTitle, parseISO8601String, gameIsSteamTitle } from '@/methods';
//import SessionLoginState from '@/state/helpers'
import ToggleButton from 'vue-js-toggle-button'

import TablePagination from '@/components/shared/TablePagination.vue';

//import * as Sentry from "@sentry/vue";
//import { BrowserTracing } from "@sentry/tracing";

Vue.mixin({
    methods: {
        parseDate: parseISO8601String,
        gameIcon: gameToGameIcon,
        gameIconLarge: gameToGameIconLarge,
        gameToTitle: gameToTitle,
        isSteamTitle: gameIsSteamTitle
    },
})

import "@/design/index.scss";
import 'leaflet/dist/leaflet.css';
import { SessionLoginState } from "@/enums";

const socket = io(process.env.VUE_APP_WS_HOST, {
    path: '/connect',
    transports: ['websocket']
});

let _tsspInterval = null;
socket.on('connect', () => {
    if (_tsspInterval) clearInterval(_tsspInterval);
    _tsspInterval = setInterval(() => { socket.emit('tssp'); }, 30000);
});
socket.on('disconnect', () => {
    if (_tsspInterval) { clearInterval(_tsspInterval); _tsspInterval = null; }
});

Vue.use(VueSocketIOExt, socket);

Vue.config.productionTip = false;
Vue.config.ignoredElements = [
    "c-content"
]

Vue.use(ToggleButton) //

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(FlagIcon);
Vue.use(vco);
Vue.use(VueToast, {
    position: 'bottom-left',
    duration: 1500,
    dismissible: true,
    pauseOnHover: true
});
Vue.use(VueSweetalert2);
Vue.use(VueMask);
Vue.use(require('vue-chartist'));
Vue.component('apexchart', VueApexCharts);
Vue.use(vueCountryRegionSelect);
Vue.component('region-select', RegionSelect);
let defaultOptions = {
    allowedTags: ['b', 'br'],
    allowedAttributes: {}
};
Vue.use(VueSanitize, defaultOptions);

Vue.use(TablePagination);

import ServerWidget from "@/components/ServerWidget";

Vue.component('ServerWidget', ServerWidget);

/* *** Filter *** */
var filter = function (text, length, clamp) {
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};
Vue.filter('truncate', filter);
/* *** ***** *** */

/* *** Prototypes *** */
Number.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}
/* ** *********** *** */

Vue.prototype.$applicationEnvironment = process.env.NODE_ENV;


/* ***************** */

/* SESSION PROTECTION */

let _clearanceState = { nonce: null, ready: false, pending: null, widgetId: null };
let _lastSolveTime = 0;
const REFRESH_MS = 7 * 60 * 1000;

function apiFetch(path, opts) {
    return fetch(process.env.VUE_APP_ROOT_API + path, Object.assign({ credentials: 'include' }, opts));
}

async function _fetchChallenge() {
    try {
        const r = await apiFetch('v1/@me/clearance/challenge');
        if (!r.ok) return null;
        return await r.json();
    } catch (e) {
        return null;
    }
}

function _getOrCreateHost() {
    let host = document.getElementById('cfcloud-clearance');
    if (!host) {
        host = document.createElement('div');
        host.id = 'cfcloud-clearance';
        host.style.cssText = 'position:fixed;bottom:20px;right:20px;z-index:99999;display:none;';
        document.body.appendChild(host);
    }
    return host;
}

async function solveClearance() {
    if (_clearanceState.pending) return _clearanceState.pending;
    _clearanceState.pending = (async () => {
        const challenge = await _fetchChallenge();
        if (!challenge || !challenge.nonce) {
            _clearanceState.pending = null;
            return false;
        }
        _clearanceState.nonce = challenge.nonce;

        return new Promise((resolve) => {
            const host = _getOrCreateHost();

            if (_clearanceState.widgetId !== null) {
                try { window.turnstile.remove(_clearanceState.widgetId); } catch (e) { /* widget already removed */ }
                _clearanceState.widgetId = null;
            }

            _clearanceState.widgetId = window.turnstile.render(host, {
                sitekey: process.env.VUE_APP_TSSP_SITEKEY,
                appearance: 'interaction-only',
                action: challenge.action,
                cData: challenge.cdata,
                'before-interactive-callback': () => { host.style.display = 'block'; },
                'after-interactive-callback': () => { host.style.display = 'none'; },
                callback: async (token) => {
                    try {
                        const ok = await apiFetch('v1/@me/clearance', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                token: token,
                                nonce: challenge.nonce
                            })
                        }).then(r => r.ok).catch(() => false);
                        _clearanceState.ready = ok;
                        if (ok) _lastSolveTime = Date.now();
                        _clearanceState.pending = null;
                        resolve(ok);
                    } catch (e) {
                        _clearanceState.pending = null;
                        resolve(false);
                    }
                },
                'error-callback': () => {
                    _clearanceState.pending = null;
                    resolve(false);
                },
                'expired-callback': () => {
                    _clearanceState.pending = null;
                    resolve(false);
                },
                'timeout-callback': () => {
                    _clearanceState.pending = null;
                    resolve(false);
                }
            });
        });
    })();
    return _clearanceState.pending;
}

window.$cloudClearance = {
    ensure: () => _clearanceState.ready ? Promise.resolve(true) : solveClearance(),
    invalidate: () => { _clearanceState.ready = false; _clearanceState.pending = null; }
};

async function _refreshIfStale() {
    if (!window.$cloudClearance) return;
    if (Date.now() - _lastSolveTime < REFRESH_MS) return;
    const ok = await solveClearance();
    if (!ok) setTimeout(() => _refreshIfStale(), 30000);
}

function _startProtectionRefresh() {
    setInterval(() => { _refreshIfStale(); }, REFRESH_MS);
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') _refreshIfStale();
    });
    window.addEventListener('online', () => { _refreshIfStale(); });
}

/* ********* */

let sessionExpiration;

fetch(process.env.VUE_APP_ROOT_API + 'v1/@me/status', { credentials: 'include' })
    .then(response => {
        if (response.ok) {
            return response.json();
        } else {
            console.error(`[CRITICAL] Failed to connect core API: (${response.status})${response.statusText}`);
        }
    })
    .then(async data => {
        sessionExpiration = parseISO8601String(data.session.expires_at);
        setTimeout(() => {
            if (new Date() >= sessionExpiration) {
                location.reload();
            }
        }, 60000);
        store.commit('setSessionExpiration', sessionExpiration);
        store.commit('setLoginState', data.state.login);

        if (store.getters.getLoginState() !== SessionLoginState.LOGGED_IN) {
            // Normal case for not logged in user
            location.replace(process.env.VUE_APP_AUTH_PROVIDER);
            return;
        } else if (!data.user.authenticated || !data.user.logged) {
            // Should the session state be manipulated
            location.replace(process.env.VUE_APP_AUTH_PROVIDER);
            return;
        }

        store.commit('setAccountId', data.user.cftools_id);

        const tsspEnabled = data.session.tssp && !!window.turnstile;
        if (tsspEnabled) {
            await Promise.race([
                window.$cloudClearance.ensure(),
                new Promise(r => setTimeout(() => r(false), 8000))
            ]);
            _startProtectionRefresh();
        } else {
            window.$cloudClearance = null;
        }

        fetch(process.env.VUE_APP_ROOT_API + 'v1/@me/bootstrap', { credentials: 'include' })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.error(`[CRITICAL] Failed to connect core API: (${response.status})${response.statusText}`);
                    if (response.status === 401) {
                        // NOT LOGGED IN
                        location.replace(process.env.VUE_APP_AUTH_PROVIDER);
                    }
                }
            })
            .then(async data => {
                if (store.getters.getAccountId() !== data.persona.cftools_id) {
                    throw new Error('Invalid account state');
                }

                let progression = data.progression;
                //store.commit('setModals', progression.modals); // TODO: Reactivate for new feature launch
                store.commit('setEntryPath', window.location.pathname);

                await store.dispatch('updateData', data);

                /*
                if (process.env.NODE_ENV === 'production') {
                    Sentry.init({
                        Vue,
                        dsn: "https://e0c50142d40b59a046d52fe0c8b5aa39@sentry.cftools.cloud/2",
                        integrations: [
                            new BrowserTracing({
                                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                                tracePropagationTargets: ["app.cftools.cloud", /^\//],
                            }),
                        ],
                        tracesSampleRate: 1.0,
                    });
                }*/

                /* Initialize main Vue instance */
                let vue_instance = new Vue({
                    router,
                    store,
                    i18n,
                    fallbackLocale: 'en',
                    render: h => h(App),
                    data() {
                        return {
                            firstClearance: false
                        };
                    },
                    sockets: {
                        connect() {
                            console.log(`[WS] UP`);
                        },
                        disconnect() {
                            console.log(`[WS] DOWN`);
                        },
                        ack(data) {
                            console.log(`[WS] Connected to ${data.id}(${data.v})@${data.s}`);
                        },
                        refresh() {
                            console.log(`[WS] Refreshing...`);
                            socket.emit('refresh');
                        },
                        update() {
                            console.log(`[WS] Updating resources...`);
                            this.updateResources();
                            console.log(`[WS] Updated`);
                            socket.emit('refresh');
                        }
                    },
                    created: function () {
                        let loadingTime = (new Date).getTime() - _timestampInit;
                        console.log(`Initialized in ${loadingTime}ms`);
                    },
                    methods: {
                        async updateResources() {
                            await this.update();
                        },
                        async update() {
                            let response = await fetch(process.env.VUE_APP_ROOT_API + 'v1/@me/bootstrap', { credentials: 'include' });
                            if (response.ok) {
                                let data = await response.json();

                                if (store.getters.getAccountId() !== data.persona.cftools_id) {
                                    location.reload();
                                    throw new Error('Invalid account state');
                                }

                                await store.dispatch('updateData', data);
                            }
                        }

                    },
                    mounted() {
                        this.$socket.$subscribe('omega:deploy', function () {
                        }); // Dummy global handler
                        this.$socket.$subscribe('presence:server', function () {
                        }); // Dummy global handler
                        this.$socket.$subscribe('user:bootstraped', function () {
                            console.log(`[WS] New tab opened`);
                        });
                        this.$socket.$subscribe('update:server', function (event) {
                            let server_id = event.server_id;

                            const data = event;
                            delete data['server_id'];
                            if (process.env.NODE_ENV === 'development') {
                                console.log(`[WS] Received update for server ${server_id}`);
                            }
                            store.commit('setServer', { server_id, data });
                        });
                        this.$socket.$subscribe('gsm:player:create', function (event) {
                            let server_id = event.server.id;
                            if (process.env.NODE_ENV === 'development') {
                                console.log(`[WS] (GSM) session created for ${server_id}`);
                            }

                            let server = store.getters.getServer(server_id);
                            const data = {
                                status: Object.assign({}, server.status)
                            };
                            data.status.players++;
                            data.status.players = Math.min(data.status.players, data.status.slots);

                            store.commit('setServer', { server_id, data });
                        });
                        this.$socket.$subscribe('gsm:player:persona', function () {
                        }); // Dummy global handler
                        this.$socket.$subscribe('gsm:player:destruct', function (event) {
                            let server_id = event.server.id;
                            if (process.env.NODE_ENV === 'development') {
                                console.log(`[WS] (GSM) session destruct for ${server_id}`);
                            }

                            let server = store.getters.getServer(server_id);
                            const data = {
                                status: Object.assign({}, server.status)
                            };
                            data.status.players--;
                            data.status.players = Math.max(data.status.players, 0);

                            store.commit('setServer', { server_id, data });
                        });
                        this.$socket.$subscribe('server:feed', function () {
                        }); // Dummy global handler
                        this.$socket.$subscribe('server:metrics', function () {
                        }); // Dummy global handler
                        this.$socket.$subscribe('server:update', function (event) {
                            let server_id = event.server_id;
                            if (process.env.NODE_ENV === 'development') {
                                console.log(`[WS] Received update from server ${server_id}`);
                            }

                            if (event.type === 'server') {
                                const data = {
                                    status: {
                                        players: event.server.population.players,
                                        slots: event.server.population.slots,
                                        queue: {
                                            active: (event.server.population.queue > 0),
                                            size: event.server.population.queue
                                        },
                                        next_restart: event.server.environment.next_restart.local,
                                        uptime: event.server.environment.uptime,
                                        environment: event.server.environment
                                    }
                                };
                                store.commit('setServer', { server_id, data });
                            }
                        });
                        this.$socket.$subscribe('server:state', function (event) {
                            let server_id = event.server.id;
                            let state = event.state.state;
                            let stateString = event.state.string;
                            if (process.env.NODE_ENV === 'development') {
                                console.log(`[WS] Server ${server_id} is now in ${stateString}`);
                            }
                            const data = {
                                state: state,
                                online: !(event.state.offline)
                            };
                            store.commit('setServer', { server_id, data });
                        });
                        let ref = this;
                        this.$socket.$subscribe('update', function () {
                        }); // Dummy global handler
                        this.$socket.$subscribe('event_subscription', function (event) {
                            console.log(`[WS] Subscription status changed`);
                            ref.updateResources();
                            console.log(`[WS] Updated`);
                            socket.emit('refresh');
                        });
                    },
                    watch: {
                        '$route'(to, from) {
                            store.commit('setRoute', to.path);
                        }
                    },
                });
                vue_instance.$mount('#app');

                let next = data.redirect.to ? data.redirect.to : window.location.pathname;
                if (progression.flags._upgrade) {
                    vue_instance.$router.push({ name: 'upgrade', params: { next: next } });
                } else if (data.redirect.to) {
                    vue_instance.$router.push(data.redirect.to);
                }
            }).catch(error => {
            console.error(`[ERROR] "${error}"`);
            //alert('Sorry, we have encountered an issue serving this request. Please refresh the page!');
            Vue.swal({
                icon: 'error',
                text: 'Sorry, we have encountered an issue serving this request (E:1)'
            }).then(function () {
                location.reload();
            });
        });
    })
    .catch(error => {
        console.error(`[ERROR] "${error}"`);
        //alert('Sorry, we have encountered an issue serving this request. Please refresh the page!');

        fetch('https://cftools.tech/api/workers/ui-status')
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.error(`[CRITICAL] Failed to retrieve maintenance status: (${response.status})${response.statusText}`);
                }
            }).then(data => {
            if (data.maintenance) {
                location.replace('https://status.cftools.cloud/maintenance');
                Vue.swal({
                    icon: 'info',
                    title: 'Maintenance (0x03)',
                    text: 'We are currently performing maintenance on our systems. Please check back later.',
                });
            } else {
                fetch('https://api.cftools.cloud/app/v1/clock').then(response => {
                        if(response.ok) {
                            Vue.swal({
                                icon: 'error',
                                text: 'We are currently unable to serve your request',
                            }).then(function () {
                                location.reload();
                            });
                        } else {
                            if(response.status === 429) {
                                Vue.swal({
                                    icon: 'warning',
                                    title: 'Rate Limit (0x09)',
                                    text: 'You have been rate limited. Please try again later.',
                                }).then(function () {
                                    location.reload();
                                });
                            } else {
                                Vue.swal({
                                    icon: 'error',
                                    title: 'Error (0x02)',
                                    text: 'We are currently experiencing technical difficulties. Please try again.',
                                }).then(function () {
                                    location.reload();
                                });
                            }
                        }
                    }).catch(error => {
                        console.error(`[ERROR] "${error}"`);
                        Vue.swal({
                            icon: 'error',
                            title: 'Error (0x05)',
                            text: 'We are currently experiencing technical difficulties. Please try again.',
                        }).then(function () {
                            location.reload();
                        });
                    });
            }
        }).catch(error => {
            console.error(`[ERROR] "${error}"`);

            Vue.swal({
                icon: 'error',
                title: 'Error (0x01)',
                text: 'You are offline or not fully connected to the internet.',
            }).then(function () {
                location.reload();
            });
        });
    });

